<div class="error-container" data-testid="server-error-state">
  <div class="error-card">
    <div class="error-icon">
      <mat-icon>error</mat-icon>
    </div>

    <h2 #statusHeading data-testid="server-error-heading" tabindex="-1">Server Configuration Error</h2>
    <p class="subtitle">Unable to verify account authorization</p>

    <div class="error-content">
      <p>
        We're unable to check if your account is authorized to access this application due to a server configuration
        issue.
      </p>

      <div class="what-to-do">
        <strong>What to do next:</strong>
        <ul>
          <li>Try again in a few minutes - this may be a temporary issue</li>
          <li>Contact support if the problem persists</li>
          <li>If you're an administrator, check the server logs for detailed error information</li>
        </ul>
      </div>

      @if (errorMessage) {
        <mat-expansion-panel class="technical-details">
          <mat-expansion-panel-header>
            <mat-panel-title>Technical Details</mat-panel-title>
          </mat-expansion-panel-header>
          <pre class="error-details" data-testid="server-error-detail">{{ errorMessage }}</pre>
        </mat-expansion-panel>
      }
    </div>

    <div class="error-actions">
      <button mat-raised-button color="primary" (click)="switchAccount()">
        <mat-icon>swap_horiz</mat-icon>
        Switch Account
      </button>
      <button mat-button (click)="retry()">
        <mat-icon>refresh</mat-icon>
        Try Again
      </button>
      <button mat-stroked-button (click)="signOut()">
        <mat-icon>logout</mat-icon>
        Sign Out
      </button>
    </div>
  </div>
</div>
